export const languageChangerObject = {
    'russian': {
        'navigation': {
            0: '',
            1: 'Отзывы',
            2: 'О клинике',
            3: 'Частые вопросы',
            4: 'Контакты',
        },
        'previewPage': {
            1: 'Indadent — клиника стоматологии в Кишинёве',
            //2: 'Ремонт и продажа рулевой рейки',
            3: 'Комплексное лечение зубов, имплантация, протезирование и профессиональная гигиена',
            4: 'Записаться на консультацию',
            //5:'100% Доверенный автосервис с локацией в Кишинёве!'//
        },
        'whyUs': {
            1: 'Почему стоит выбрать нас?',
            2: 'Доступные цены',
            3: 'Квалифицированный персонал',
            4: 'Персональная гарантия',
            5: 'Используем для ремонта новые запчасти',
            6: 'Маршрут к клинике',
            7: 'Отзывы клиентов',
            8: 'Смотреть все отзывы',
            9: "Опытные врачи",
            10: "Работаем аккуратно",
            11: "Квалифицированные врачи и ассистенты",
            12: "Современное оборудование и материалы",
        },
        'shortAdd': {
            1: 'Широкий выбор стоматологических услуг в Молдове!',
            2: 'У нас вы найдёте всё: от профессиональной чистки до имплантации — качественно и с заботой!',
            3: 'Связаться сейчас',
        },
        'shortAdd2': {
            1: 'Проверка зубов — быстро и без боли',
            2: 'Чувствуете дискомфорт, боль или давно не были у стоматолога? Запишитесь к нам на диагностику уже сегодня!',
            3: 'Записаться',
        },
        'aboutUs': {
            1: 'О клинике',
            2: 'Стоматология Indadent — это современная клиника, специализирующаяся на лечении, протезировании и эстетической стоматологии. Мы используем передовые технологии и заботу наших специалистов, чтобы подарить вам уверенную и красивую улыбку.',
            9: 'Мы точно знаем, как избавить вас от боли, восстановить зубы и подарить комфорт на каждом этапе лечения.',
            10: 'У нас есть всё, чтобы провести лечение качественно — от диагностики до сложных хирургических процедур. Мы заботимся о вашем здоровье так, как о своём.',
            11: 'Посмотрите стоимость процедур:',
            12: 'Прайс-лист'
        },
        'contactsPage': {
            'form': {
                1: 'Или опишите вашу проблему и мы вам перезвоним',
                2: 'Ваш номер телефона*',
                3: 'Ваша Фамилия',
                4: 'Козарь...',
                5: 'Ваше Имя',
                6: 'Алина...',
                7: 'Расскажите нам о вашей проблеме',
                8: 'Например: Уже несколько дней у меня болит зуб на холодну',
                9: 'Ваша заявка была успешна отправлена! Ожидайте ответа.',
                10: 'Отправить',
                11: '* Это поле обязательно для заполнения',
				details: 'Для детальной консультации, позвоните нам прямо сейчас!',
            },
            'contacts': {
                1: 'Контакты',
                2: 'г. Кишинёв, сек. Центр, ул. Николае Анестиаде 6',
                3: 'Пн-Пт: 8.30 — 19.00, Сб: 9.00 — 14.00',
				requisites: 'Банковские реквизиты:'
            },
            'bank-details_header': {
                1: 'Rechizite bancare:',
                2: 'mun. Chisinau, sec. Centru, str. Nicolae Anestiade 6, of. 4',
                3: 'Lu-Vi: 8:30 — 18:00',
            },
            'form-info': {
                1: 'sss',
            },
        },
        'restorationLocale': {
            1: 'Что мы восстанавливаем?',
        },
        'QALocale': {
            oftenAsked: 'Часто задаваемые вопросы',
            newRack: 'Больно ли лечить зубы?',
            newRackDescription: 'Большинство процедур проводятся под местной анестезией и проходят комфортно. Мы делаем всё, чтобы вы чувствовали себя спокойно.',
            signsOfBroken: 'Когда нужно обращаться к стоматологу?',
            signsOfBrokenDescription: 'Регулярно — каждые 6 месяцев. А также при боли, чувствительности или визуальных изменениях зубов и десен.',
            qaQuestion1: 'Что лучше: пломба или коронка?',
            qaQuestion1Description: 'Это зависит от степени разрушения зуба. Врач подскажет оптимальный вариант после осмотра.',
            qaQuestion2: 'Как подготовиться к приёму у стоматолога?',
            qaQuestion2Description: 'За 1–2 часа до приёма желательно поесть, почистить зубы и не использовать алкоголь или обезболивающее — это может исказить ощущения и затруднить диагностику.',
            qaQuestion3: 'Можно ли поставить имплант, если давно удалён зуб?',
            qaQuestion3Description: 'Да, но может потребоваться дополнительная подготовка (например, наращивание кости). Всё решается индивидуально.',
            qaQuestion4: 'Что делать, если скололся зуб?',
            qaQuestion4Description: 'Не откладывайте визит. Даже маленький скол может привести к разрушению зуба. Мы восстановим его форму и функцию с помощью пломбы или вкладки.',
            qaQuestion5: 'Можно ли лечить зубы во время беременности?',
            qaQuestion5Description: 'Да, особенно во втором триместре. Мы используем безопасные препараты и подбираем щадящий план лечения с учётом вашего состояния.',
            qaQuestion6: 'Можно ли лечить зубы, если простыл или болит горло?',
            qaQuestion6Description: 'Лёгкая простуда — не противопоказание, но при высокой температуре или сильном воспалении лучше перенести приём. Ваше здоровье и безопасность — в приоритете.',
            qaQuestion7: 'Доп Вопрос 7',
            qaQuestion7Description: 'Доп 7 описание',
            qaQuestion8: 'Доп Вопрос 8',
            qaQuestion8Description: 'Доп 8 описание',
        },
        'footer': {
            1: 'Сайт разработан при поддержке',
            2: ' при поддержке '
        }
    },
    'romanian': {
        'navigation': {
            0: '',
            1: 'Recenzii',
            2: 'Despre clinică',
            3: 'Întrebări frecvente',
            4: 'Contacte',
        },
        'previewPage': {
            1: 'Indadent — clinica stomatologică în Chișinău',
         //   2: 'Repararea și vânzarea casetelor de direcție',
            3: 'Tratament dentar complex, implanturi, proteze și igienizare profesională',
            4: 'Programează o consultație',
            //5:'service auto de Încredere cu locație în Chișinău!'
        },
        'whyUs': {
            1: 'De ce trebuie să ne alegi?',
            2: 'Prețuri accesibile',
            3: '-',
           // 4: 'Specialiști cu experiență',
           // 5: 'Piese de schimb calitative',
            6: 'Vezi locația',
            7: 'Recenziile de la pacienți',
            8: 'Toate recenziile',
            9: "Specialiști cu experiență",
            10: "Tratăm cu grijă",
            11: "Medici și asistenți calificați",
            12: "Echipamente și materiale moderne",
        },
        'shortAdd': {
            1: "O gamă largă de servicii stomatologice în Moldova!",
            2: "De la curățare profesională până la implanturi – totul cu grijă și calitate!",
            3: "Contactează-ne acum",
        },
        'shortAdd2': {
            1: "Programează-te pentru un control stomatologic",
            2: "Simți disconfort, durere sau n-ai mai fost de mult la dentist? Programează-te la noi pentru o consultație!",
            3: "Programează-te",
        },
        'aboutUs': {
            1: 'Despre clinică',
            2: "Indadent este o clinică stomatologică modernă, specializată în tratamente dentare, protezare și estetică dentară. Folosim tehnologii de ultimă generație și grijă autentică pentru a vă reda zâmbetul cu încredere.",
            9: "Știm exact cum să eliminăm durerea, să refacem dantura și să vă oferim confort la fiecare pas.",
            10: "Avem tot ce este necesar pentru un tratament calitativ – de la diagnostic până la intervenții complexe. Ne pasă de sănătatea dumneavoastră ca de a noastră.",
            11: 'Vedeți lista de prețuri:',
            12: 'Lista de prețuri',
        },
        'contactsPage': {
            'form': {
                1: 'Sau descrie-ne ce te deranjează și te sunăm înapoi',
                2: 'Telefonul tău*',
                3: 'Nume',
                4: 'Cozari...',
                5: 'Prenume',
                6: 'Alina...',
                7: 'Descrie-ne problema ta',
                8: 'Exemplu: Simt dureri la rece de cateva zile...',
                9: 'Datele au fost trimise cu succes! Așteaptă un sunet',
                10: 'Trimite',
                11: '* Este necesar să completezi măcar acest câmp',
				details: 'Pentru o consultanță detaliată, sună chiar acum!',
            },
            'contacts': {
                1: 'Contacte',
                2: 'mun. Chisinau, sec. Centru, str. Nicolae Anestiade 6, of. 4',
                3: 'Lu-Vi: 8:30 — 19:00, Sâ: 09:00 — 14:00',
				requisites: 'Datele bancare:'
            },
            'bank-details': {
                1: 'Rechizite bancare:',
                2: 'mun. Chisinau, sec. Centru, str. Nicolae Anestiade 6, of. 4',
                3: 'Lu-Vi: 8:30 — 19:00, Sâ: 09:00 — 14:00',
            },
            'form-info': {
                1: 'sss',
            }
        },
        'restorationLocale': {
            1: 'Ce reparăm în sistemul de direcție?',
        },
        'QALocale': {
            oftenAsked: 'Întrebări frecvente',
            newRack: 'Este dureros tratamentul dentar?',
            newRackDescription: 'Majoritatea tratamentelor se fac cu anestezie locală și sunt complet suportabile. Ne asigurăm că te simți confortabil.',
            signsOfBroken: 'Cât de des trebuie să merg la stomatolog?',
            signsOfBrokenDescription: 'Ideal la fiecare 6 luni. Dar și atunci când apare durere, sensibilitate sau modificări vizibile la dinți sau gingii.',
            qaQuestion1: 'Ce e mai bine: plombă sau coroană?',
            qaQuestion1Description: 'Depinde de cât de afectat este dintele. Medicul va recomanda varianta optimă în urma consultației.',
            qaQuestion2: 'Cum mă pregătesc pentru o programare la dentist?',
            qaQuestion2Description: 'Este recomandat să mănânci cu 1–2 ore înainte, să te speli pe dinți și să eviți alcoolul sau analgezicele – acestea pot influența asupra senzațiilor în timpul verifiicării.',
            qaQuestion3: 'Pot face un implant dacă am pierdut un dinte demult?',
            qaQuestion3Description: 'Da, dar poate fi necesară o pregătire suplimentară (ex. adiție de os). Fiecare caz este unic.',
            qaQuestion4: 'Ce fac dacă mi s-a ciobit un dinte?',
            qaQuestion4Description: 'Nu amâna vizita. Chiar și o ciobire minoră poate duce la complicații. Refacem dintele cu o plombă sau o fațetă, în funcție de caz.',
            qaQuestion5: 'Pot trata dinții în timpul sarcinii?',
            qaQuestion5Description: 'Da, mai ales în al doilea trimestru. Folosim materiale sigure și stabilim un plan de tratament adaptat stării tale.',
            qaQuestion6: 'Pot merge la dentist dacă am răcit sau mă doare gâtul, sau am herpes?',
            qaQuestion6Description: 'O răceală ușoară nu este o contraindicație, însă dacă ai febră mare sau o inflamație serioasă, este mai bine să reprogramezi vizita. Sănătatea ta este prioritară.',
            qaQuestion7: 'Доп Вопрос 7',
            qaQuestion7Description: 'Доп 7 описание',
            qaQuestion8: 'Доп Вопрос 8',
            qaQuestion8Description: 'Доп 8 описание',
        },
        'footer': {
            1: 'Site-ul a fost dezvoltat de către',
            2: " cu suportul "
        }
    }
}